import React, { Component } from 'react';
import {VTab, VTabs, ContentGroup} from '../Styles';
import {Switch, Route, Link, Redirect} from 'react-router-dom';
import Profile from '../Employers/Profile';
import {Jobs, VTabAlert, Applicants} from '.';
import {Settings} from '../Employers';
import { NewAlert, EditAlert } from '../Alerts';
import {UserService} from '../../lib/qc-api-client';
import Loader from "../Shared/Loader";
import Candidates from './Candidates/index';
import Help from './Help';

const SectionTabs = (props) => {
  const isLocation = (pathname) => {
    return window.location.pathname === pathname;
  }
  const capitalizeFirstLetter = (word) => {
    return word[0].toUpperCase() + word.slice(1);
  }
  return (
    <VTabs className="hidden-xs">
    {props.sections.map((section, index) =>
      <VTab key={index} className={isLocation(`/dashboard/${section}`) && 'active'}>
        <Link to={`/dashboard/${section}`} data-toggle="tab">{
          capitalizeFirstLetter(section)
        }</Link>
      </VTab>
    )}
    </VTabs>
  )
}

export default class Dashboard extends Component {

  state = {};

  componentWillMount() {
    if (this.props.user) {
      this.getAlerts();
    }
    window.scrollTo(0, 0);
  }

  shouldComponentRender = () => {
    const { user } = this.props;
    if (user === undefined) return false;
    return true;
  }

  handleChange = (event) => {
    let name = event.target.name;
    let value = event.target.value
    this.setState({[name]: value})
  }

  getAlert = (id) => {
    return this.state.alerts && this.state.alerts.filter(alert => alert.id === id)[0];
  }

  getJob = (slug) => {
    return this.state.jobs && this.state.jobs.filter(job => job.slug === slug)[0];
  }

  getApplicant = (id) => {
    return this.state.applicants && this.state.applicants.filter(applicant => applicant.id === id)[0];
  }

  getAlerts = () => {
    if (this.props.user) {
      UserService.getUserAlerts(this.props.user)
        .then(response => {
          this.setState({alerts: response.data.alerts});
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  deleteAlert = (alert) => {
    UserService.removeUserAlert(alert)
      .then(response => {
        let newArray = this.state.alerts.filter(a => a.id !== alert.id);
        this.setState({ alerts: [...newArray] })
      })
      .catch(error => console.error(error.message));
  }

  render() {
    if (!this.shouldComponentRender()) return <Loader fullScreen vwidth="70vw" show={true} />

    const { user } = this.props;
    const sections = ['jobs', 'candidates', 'settings', 'help'];
    return (
      <div>
        <SectionTabs sections={sections}/>
        <ContentGroup>
          <Switch>
            <Route exact path='/dashboard' render={() => <Redirect to="/dashboard/jobs"/>}/>
            <Route exact path='/dashboard/jobs/:jobId/applicants/:profileId' render={(props) => {
              return <Profile id={props.match.params.profileId} job={this.getJob(props.match.params.jobId)} />
            }}/>
            <Route exact path='/dashboard/jobs' render={() => <Jobs user={this.props.user} /> }/>
            <Route exact path='/dashboard/candidates' render={(props) => <Candidates {...this.props}/>}/>
            <Route exact path='/dashboard/jobs/:jobId/applicants' render={(props) =>
              <Applicants jobId={props.match.params.jobId} />
            }/>
            <Route exact path='/dashboard/settings' render={() => <Settings {...this.props}/>}/>
            <Route exact path='/dashboard/help' render={(props) => <Help {...this.props}/> }/>
          </Switch>
        </ContentGroup>
      </div>
    );
  }

}
